<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1.5625 9.03031V17.9688C1.5625 19.6946 2.96161 21.0938 4.6875 21.0938H20.3125C22.0384 21.0938 23.4375 19.6946 23.4375 17.9688V9.03031L14.1378 14.7532C13.1334 15.3713 11.8666 15.3713 10.8622 14.7532L1.5625 9.03031Z"
				:fill="color"
				:stroke="strokeColor"
				:stroke-width="strokeWidth"
			/>
			<path
				d="M23.4375 7.19565V7.03125C23.4375 5.30536 22.0384 3.90625 20.3125 3.90625H4.6875C2.96161 3.90625 1.5625 5.30536 1.5625 7.03125V7.19565L11.6811 13.4225C12.1833 13.7315 12.8167 13.7315 13.3189 13.4225L23.4375 7.19565Z"
				:fill="color"
				:stroke="strokeColor"
				:stroke-width="strokeWidth"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgEmail',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
		strokeColor: {
			type: String,
			default: null,
		},
		strokeWidth: {
			type: Number,
			default: 1.5,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
